<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable
		class="bs-popup">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">
				{{$t('验证邮箱')}}</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body">
				<el-form ref="form" :model="form">
					<el-form-item >
						<el-input v-model="form.email" :placeholder="$t('请输入邮箱')"></el-input>
					</el-form-item>
					<el-form-item >
						<div class="flex">
							<div class="flex-col">
								<el-input v-model="form.code" :placeholder="$t('请输入验证码')"></el-input>
							</div>
							<el-button class="get-code" type="warning" @click="getCode" :disabled="countdown > 0">
								{{ countdown > 0 ? `${countdown}s` : $t('发送验证码') }}
							</el-button>
						</div>
					</el-form-item>
					<el-row :gutter="20" class="btn-foot-row">
						<el-col :span="12">
							<el-button round  type="warning">取消</el-button>
						</el-col>
						<el-col :span="12">
							<el-button round type="primary" @click="onSubmit">确定</el-button>
						</el-col>
					</el-row>	
				</el-form>
			</div>
		</div>
	</van-popup>

</template>
<script>
	import {send_email_code_api,check_mobile_email_api} from "@/api/user"
	export default {
		components: {},
		data() {
			return {
				show: false,
				form: {
					email: '',
					code: '',
				},
				countdown: 0,
			};
		},
		methods: {
			async getCode(){
				if (this.form.email == "") {
					this.errorTips("请输入邮箱");
					return false;
				}
				let param = {
					email: this.form.email,
					type: 2,
				};
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				const res = await send_email_code_api(param);
				loading.close();
				console.log(res.data,'获取验证码')
				if (res && res.data && res.data.code == 1) {
					this.$message.success(res.data.msg);
					this.startCountdown();
				} else {
					this.errorTips(res.data.msg);
				}
			},
			startCountdown() {
			  this.countdown = 60;
			  const interval = setInterval(() => {
				if (this.countdown > 0) {
				  this.countdown--;
				} else {
				  clearInterval(interval);
				}
			  }, 1000);
			},
			async onSubmit() {}
		},
		mounted() {}
	}
</script>
<style scoped>
	.get-code{
		border-radius: 0;
		margin-left: 10px;
	}
	.btn-foot-row{
		padding: 10px 0;
	}
	.btn-foot-row .el-button{
		width: 100%;
	}
</style>